import { Loader } from "@mantine/core";
import { createContext, useContext } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { Location } from "../shared/location";
import { CompanyContext } from "./CompanyGateway";

// @ts-expect-error We know we will have a location here so use this to avoid unwrapping all the time.
export const LocationContext = createContext<Location>(null);

export default function CompanyGateway({children}: {children: React.ReactNode}) {
  const company = useContext(CompanyContext);

  const [locationSS, loading, error] = useDocument(Location.ref(company.id, company.defaultLocation));
  const location = locationSS?.data();

  if (loading) return <Loader />;

  if (!location || error) {
    throw new Error(`404 unknown host ${location?.id}`);
  }

  return <LocationContext.Provider value={location} >
    {children}
  </LocationContext.Provider>
}